import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateDriverEntity } from '../../domain/entities/CreateUpdateDriverEntity'

export class CreateUpdateDriverModel extends CreateUpdateDriverEntity {
  regionId?: number
  salarySystemId?: number
  avatarImageFile!: { bytes: string; fileName: string }
  vehicleTemplateId?: number
  driverTeamIds?: Array<number> | null

  constructor(dataDto: CreateUpdateDriverEntity) {
    super()
    mapEntityProperties<CreateUpdateDriverModel>(this, dataDto, {
      exclude: ['region', 'salarySystem', 'imageData', 'vehicleTemplate', 'driverTeams'],
      map: {
        regionId: dataDto.region?.id,
        salarySystemId: dataDto.salarySystem?.id,
        avatarImageFile: dataDto.imageData,
        vehicleTemplateId: dataDto.vehicleTemplate?.id,
        driverTeamIds: dataDto.driverTeams?.map((driverTeam) => driverTeam.id),
        // Always send an explicit value so clearing it (null) removes the default day off on the backend
        defaultDayOff: dataDto.defaultDayOff ?? null
      }
    })
  }
}
